// CRUD
export const CREATE_CONSULTATION_REQUEST = "CREATE_CONSULTATION_REQUEST";
export const CREATE_CONSULTATION_SUCCESS = "CREATE_CONSULTATION_SUCCESS";
export const CREATE_CONSULTATION_FAILURE = "CREATE_CONSULTATION_FAILURE";

export const DELETE_CONSULTATION_REQUEST = "DELETE_CONSULTATION_REQUEST";
export const DELETE_CONSULTATION_SUCCESS = "DELETE_CONSULTATION_SUCCESS";
export const DELETE_CONSULTATION_FAILURE = "DELETE_CONSULTATION_FAILURE";

export const GET_CONSULTATION_BY_ID_REQUEST = "GET_CONSULTATION_BY_ID_REQUEST";
export const GET_CONSULTATION_BY_ID_SUCCESS = "GET_CONSULTATION_BY_ID_SUCCESS";
export const GET_CONSULTATION_BY_ID_FAILURE = "GET_CONSULTATION_BY_ID_FAILURE";

// Liste plate par patient
export const GET_CONSULTATIONS_BY_PATIENT_REQUEST = "GET_CONSULTATIONS_BY_PATIENT_REQUEST";
export const GET_CONSULTATIONS_BY_PATIENT_SUCCESS = "GET_CONSULTATIONS_BY_PATIENT_SUCCESS";
export const GET_CONSULTATIONS_BY_PATIENT_FAILURE = "GET_CONSULTATIONS_BY_PATIENT_FAILURE";
